"use client";

import { cn } from "@/lib/utils";
import { clampQuantity } from "./pricingRates";

interface QuantityInputProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (value: number) => void;
  className?: string;
}

/** Inline number field that keeps its value inside the pricing bounds. */
const QuantityInput = ({
  label,
  value,
  min,
  max,
  step,
  onChange,
  className,
}: QuantityInputProps) => (
  <input
    type="number"
    aria-label={label}
    value={value}
    min={min}
    max={max}
    step={step}
    onChange={(event) =>
      onChange(clampQuantity(Number(event.target.value), min, max))
    }
    className={cn(
      "rounded-[8px] border border-input bg-background px-1.5 py-[5px]",
      "text-right text-[13.5px] font-bold text-foreground",
      "transition-colors hover:border-primary focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-card",
      className,
    )}
  />
);

export default QuantityInput;
